import React from 'react'
import { useTranslation } from 'react-i18next'
import { WidgetGuard } from 'features/types'
import { useDashboardWidgetData } from 'hooks/useWidgetState'
import { InsightCount } from 'schemas/action/InsightCountSchema'
import ErrorMessage from 'components/share/ErrorMessage'
import { retrieveInsightDataSet } from '../Channels/utils'

const ChannelsEmptyResultGuard: WidgetGuard = ({ widgetId, children }) => {
  const { t } = useTranslation()
  const widgetData = useDashboardWidgetData<InsightCount>(widgetId)
  const insightDataSet = retrieveInsightDataSet(widgetData)

  if (insightDataSet.length === 0) return <ErrorMessage>{t('cannotDisplayData')}</ErrorMessage>
  return children
}

export default ChannelsEmptyResultGuard
